export const DFOS_LIST= 'DFOS_LIST';
export const DFOS_LIST_SUCCESS = 'DFOS_LIST_SUCCESS';
export const DFOS_LIST_ERROR = 'DFOS_LIST_ERROR';

export const ADD_DFOS_LIST = 'ADD_DFOS_LIST';
export const ADD_DFOS_LIST_SUCCESS = 'ADD_DFOS_LIST_SUCCESS';
export const ADD_DFOS_LIST_ERROR = 'ADD_DFOS_LIST_ERROR';

export const EDIT_DFOS_LIST = 'EDIT_DFOS_LIST';
export const EDIT_DFOS_LIST_SUCCESS = 'EDIT_DFOS_LIST_SUCCESS';
export const EDIT_DFOS_LIST_ERROR = 'EDIT_DFOS_LIST_ERROR';

export const DFOS_LIST_DETAILS = 'DFOS_LIST_DETAILS';
export const DFOS_LIST_DETAILS_SUCCESS =  'DFOS_LIST_DETAILS_SUCCESS';
export const DFOS_LIST_DETAILS_ERROR = 'DFOS_LIST_DETAILS_ERROR';

export const DELETE_DFOS_LIST = 'DELETE_DFOS_LIST';
export const DELETE_DFOS_LIST_SUCCESS = 'DELETE_DFOS_LIST_SUCCESS';
export const DELETE_DFOS_LIST_ERROR  = 'DELETE_DFOS_LIST_ERROR';


export const USERS_LIST = 'USER_LIST';
export const USERS_LIST_SUCCESS = 'USERS_LIST_SUCCESS';
export const USERS_LIST_ERROR = 'USERS_LIST_ERROR';


